module.exports = __webpack_public_path__ + "static/img/ct.3d79b2a3.png";